import { render } from "./GraficoStatusPrazoProjetos.vue?vue&type=template&id=84725162&scoped=true"
import script from "./GraficoStatusPrazoProjetos.vue?vue&type=script&lang=js"
export * from "./GraficoStatusPrazoProjetos.vue?vue&type=script&lang=js"

import "./GraficoStatusPrazoProjetos.vue?vue&type=style&index=0&id=84725162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84725162"]])

export default __exports__